import { useUserDisplayNamesStore } from 'Global/User/UserDisplayNameStore';

/**
 * The user types a customer may request, sourced from the app-wide display-names store
 * (populated on app load from the cached fetch-user-display-types endpoint). Excludes the
 * account's current type — requesting it again is rejected server-side anyway.
 */
export const useRequestableUserTypes = (currentUserDisplayNameId?: string | null) => {
	const userDisplayNames = useUserDisplayNamesStore(state => state.userDisplayNames);
	return userDisplayNames.filter(x => x.requestable && x.id !== currentUserDisplayNameId);
};
